import React from 'react'

import styles from './BeneficiarioDobleAsegurado.module.css'

import Subtitle from '../Subtitle/Subtitle'
import BarraProgreso from '../ProgresBar/BarraPorcentaje'

const BeneficiarioDobleAsegurado = () => {
  
  return (
    <React.Fragment>
      <div className={styles['areadatosprospecto']}>
        <Subtitle sname={'Beneficiarios Principales'} smostrar={true} sparrafo={''} />
        <div className={styles['areadatosprospecto__accion']}>
          <BarraProgreso total={100} />   
        </div>
        <p className={styles['areadatosprospecto_p']}>
          Mediante la firma de la presente solicitud, el contratante, el asegurado titular y el asegurado adicional declaran conocer y aceptar que el beneficiario, en caso de fallecimiento del asegurado titular, será el asegurado adicional y que el beneficiario, en caso de fallecimiento del asegurado adicional, será el asegurado titular. Asimismo, declaran conocer y aceptar que, en caso ambos asegurados fallecieran de manera simultánea, la Compañía pagará únicamente la suma asegurada correspondiente a un solo siniestro, pero dividirá dicho monto en dos (02) partes iguales, cada una de las cuales se otorgarán a los herederos legales de cada uno de los asegurados.
        </p>
      </div>
    </React.Fragment>
  )
}

export default BeneficiarioDobleAsegurado